var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.537,
    viewBox: "0 0 17 16.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10174",
    "data-name": "Group 10174",
    transform: "translate(21833 2469.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5247",
    "data-name": "Path 5247",
    className: "cls-1",
    d: "M.3,7.722,8.048.6a.369.369,0,0,1,.5,0L16.3,7.722",
    transform: "translate(-21832.801 -2469.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1834",
    "data-name": "Ellipse 1834",
    className: "cls-2",
    cx: 1.257,
    cy: 1.257,
    r: 1.257,
    transform: "translate(-21825.758 -2455.514)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10175",
    "data-name": "Group 10175",
    transform: "translate(-21831.014 -2465.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5246",
    "data-name": "Path 5246",
    className: "cls-1",
    d: "M85.212,88.3h0V98.861a.832.832,0,0,1-.8.867H80.572",
    transform: "translate(-71.954 -88.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7396",
    "data-name": "Path 7396",
    className: "cls-1",
    d: "M47.74,108.835H43.9a.832.832,0,0,1-.8-.867v-7.923",
    transform: "translate(-43.1 -97.406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/DashboardWhite.06238e42ac37d8432dda12f97e180bb9.svg";
export { ForwardRef as ReactComponent };